<template>
  <el-dialog :title="dialogTitle" :visible.sync="_visible" width="868px" @close="onClose" custom-class="edit-dialog-wrapper" :close-on-click-modal="false">
    <el-form ref="editFrom" label-width="98px" :model="editFrom" inline :rules='rules'>
      <el-card>
        <el-form-item label="客户姓名">
          <el-input v-model="editFrom.name" disabled class="edit-input"></el-input>
        </el-form-item>
        <el-form-item label="是否参会">
          <el-select v-model="editFrom.attend" placeholder="请选择" @change="onAttendChange">
            <template v-for="item in constants.AttendOptions">
              <el-option :label="item.label" :value="item.value" :key="item.label" :disabled="item.value === constants.Attend02">
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="住宿安排">
          <el-select v-model="editFrom.accomodation" placeholder="请选择" :disabled="isNoAttend"
            @change="onAccomodationChange"
          >
            <template v-for="item in constants.AccomodationOptions">
              <el-option :label="item.label" :value="item.value" :key="item.label">
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="是否晚宴">
          <el-select v-model="editFrom.dinner" placeholder="请选择" :disabled="isNoAttend">
            <template v-for="item in constants.DinnerOptions">
              <el-option :label="item.label" :value="item.value" :key="item.label">
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="房型需求">
          <el-select v-model="editFrom.room" placeholder="请选择" :disabled="isNoAttend">
            <template v-for="item in ROOM_TYPE_LIST">
              <el-option :label="item.label" :value="item.value" :key="item.label">
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-divider content-position="left">接机/站安排</el-divider>
        <el-form-item label="接机/站安排" style="display: block;">
          <el-select v-model="editFrom.receive" placeholder="请选择" @change="onReceiveChange" :disabled="isNoAttend">
            <template v-for="item in constants.ReceiveOptions">
              <el-option :label="item.label" :value="item.value" :key="item.label">
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-collapse-transition>
          <div v-show="editFrom.receive === constants.Receive01" key="receive1">
            <el-form-item label="联系电话" prop="receivePhone" key="receivePhone">
              <el-input v-model="editFrom.receivePhone" class="edit-input"></el-input>
            </el-form-item>
            <el-form-item label="到达站点" key="StationOptions">
              <el-select v-model="editFrom.receiveStation" placeholder="请选择">
                <template v-for="item in constants.StationOptions">
                  <el-option :label="item.label" :value="item.value" :key="item.label">
                  </el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item label="航班号/车次" key="receiveNumber">
              <el-input v-model="editFrom.receiveNumber" placeholder="请输入航班号/车次，MUXXXX或GXXXX" class="edit-input"></el-input>
            </el-form-item>
            <el-form-item label="到达日期时间" key="receiveTime">
              <el-select v-model="receiveDate" placeholder="请选择" style="width: 152px" @change="onDateChange('receiveDate','receiveTime')">
                <template v-for="item in receiveDateOption">
                  <el-option :label="item.text" :value="item.value" :key="item.value">
                  </el-option>
                </template>
              </el-select>
              <el-time-select
                  v-model="receiveMin"
                  :picker-options="receiveMinOption"
                  format="HH:mm"
                  @change="onDateChange('receiveMin','receiveTime')"
                  placeholder="选择时间" style="width: 118px">
              </el-time-select>
            </el-form-item>
            <el-form-item label="同行人" style="display: block;" key="receiveCompany">
              <el-input v-model="editFrom.receiveCompany" placeholder="请输入" class="edit-input"></el-input>
            </el-form-item>
          </div>
        </el-collapse-transition>
        <el-divider content-position="left">送机/站安排</el-divider>
        <el-form-item label="送机/站安排" style="display: block;">
          <el-select v-model="editFrom.send" placeholder="请选择" @change="onSendChange" :disabled="isNoAttend">
            <template v-for="item in constants.ReceiveOptions">
              <el-option :label="item.label" :value="item.value" :key="item.label">
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-collapse-transition>
          <div v-show="editFrom.send === constants.Receive01">
            <el-form-item label="联系电话" prop="sendPhone">
              <el-input v-model="editFrom.sendPhone" class="edit-input"></el-input>
            </el-form-item>
            <el-form-item label="出发站点">
              <el-select v-model="editFrom.sendStation" placeholder="请选择">
                <template v-for="item in constants.StationOptions">
                  <el-option :label="item.label" :value="item.value" :key="item.label">
                  </el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item label="酒店出发时间">
              <el-select v-model="sendDate" placeholder="选择日期" style="width: 152px" @change="onDateChange('sendDate','sendTime')">
                <template v-for="item in sendDateOption">
                  <el-option :label="item.text" :value="item.value" :key="item.text">
                  </el-option>
                </template>
              </el-select>
              <el-time-select
                  v-model="sendMin"
                  :picker-options="sendMinOption"
                  format="HH:mm"
                  @change="onDateChange('sendMin','sendTime')"
                  placeholder="选择时间" style="width: 118px">
              </el-time-select>
            </el-form-item>
          </div>
        </el-collapse-transition>

        <el-form-item label="备注" key="remark">
          <el-input
            type="textarea"
            v-model="editFrom.remark"
            placeholder="备注"
            class="edit-input"
          ></el-input>
        </el-form-item>
      </el-card>
    </el-form>
    <div slot="footer">
      <el-button style="width: 150px;" @click="onClose">取消</el-button>
      <el-button style="width: 150px;" @click="onSubmit">保存</el-button>
    </div>
  </el-dialog>

</template>

<script>
import { ROOM_TYPE_LIST, ROOM_TYPE_0, ROOM_TYPE_1 } from '@/common/index';
import constants, {Attend00, Attend01, Attend02} from '@/util/constants'
import {userOperateResult} from '@/service/adminApis'
import lodash from "lodash";
import {getMobileTest} from "@/util/common";
import { Accomodation00 } from '@/util/constants';
import moment from "moment";

export default {
  name: "AddOrUpdateQuestion",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    values: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      ROOM_TYPE_LIST,
      editFrom: {
        remark: "",
        room: "",
        name: "",
        clientId: '',
        channelManager: '',
        phone: "",
        attend: '',
        accomodation: '',
        dinner: '',
        receive: '',
        receivePhone: '',
        receiveStation: '',
        receiveNumber: '',
        receiveTime: '',
        receiveCompany: '',
        send: '',
        sendPhone: '',
        sendStation: "",
        sendTime: "",
      },
      constants,
      rules: {
        sendPhone: [
          {validator: this.validatePhone, trigger: 'blur'}
        ],
        receivePhone: [
          {validator: this.validatePhone, trigger: 'blur'}
        ],
      },
      receiveDate: null,
      receiveMin: null,
      sendDate: null,
      sendMin: null
    }
  },
  computed: {
    // 到达时间选择
    receiveDateOption() {
      const key = this.editFrom.accomodation || constants.Accomodation01;
      const conList = constants.ReceiveDateRange[key];
      return conList;
    },
    receiveMinOption() {
      const { children } = this.receiveDateOption.find((_) => this.receiveDate === _.value) || {};
      if (!this.receiveDate || !children) {
        return {
          start: '00:00',
          step: '00:05',
          end: '24:00'
        }
      }
      const endHData = children[children.length - 1];
      return {
        start: `${children[0].text}:00`,
        step: '00:05',
        end: `${endHData.text}:${endHData.children[endHData.children.length - 1].text}`
      }
    },
    // 酒店出发时间
    sendDateOption() {
      const key = this.editFrom.accomodation || constants.Accomodation01;
      const conList = constants.SendDateRange[key];
      return conList;
    },
    sendMinOption() {
      const { children } = this.sendDateOption.find((_) => this.sendDate === _.value) || {};
      if (!this.sendDate || !children) {
        return {
          start: '00:00',
          step: '00:05',
          end: '24:00'
        }
      }
      const endHData = children[children.length - 1];
      return {
        start: `${children[0].text}:00`,
        step: '00:05',
        end: `${endHData.text}:${endHData.children[endHData.children.length - 1].text}`
      }
    },
    _visible: {
      get() {
        return this.visible || false
      },
      set(newVal) {
        return newVal
      }
    },
    receivePicker() {
      const key = this.editFrom.accomodation || constants.Accomodation01;
      const conList = constants.ReceiveDateRange[key];
      if (!this.receiveDate) {
        return {
          step: '00:05',
          start: '00:00',
          end: '23:55'
        };
      }
      const label = constants.ReceiveDateOptions.find(item => item.value === this.receiveDate).label;
      const data = conList.find(item => item.text === label);
      const max = `${data.children[0].text}:${data.children[0].children[0].text}`;
      const Hfin = data.children.length - 1;
      const Mfin = data.children[Hfin].children.length - 1;
      const min = `${data.children[Hfin].text}:${data.children[Hfin].children[Mfin].text}`;
      return {
        step: '00:05',
        start: max,
        end: min,
      };
    },
    // 到达
    arrivalTimeOption() {
      const key = this.editFrom.accomodation || constants.Accomodation01;
      const conList = constants.ReceiveDateRange[key];
      const labelList = conList.map((item) => item.text);
      const receiveList = constants.ReceiveDateOptions.filter(item => labelList.includes(item.label))
      return receiveList;
    },
    sendPicker() {
      const key = this.editFrom.accomodation || constants.Accomodation01;
      const conList = constants.SendDateRange[key];
      if (!this.sendDate) {
        return {
          step: '00:05',
          start: '00:00',
          end: '23:55'
        };
      }
      const label = constants.DateOptions.find(item => item.value === this.sendDate).label;
      const data = conList.find(item => item.text === label);
      const max = `${data.children[0].text}:${data.children[0].children[0].text}`;
      const Hfin = data.children.length - 1;
      const Mfin = data.children[Hfin].children.length - 1;
      const min = `${data.children[Hfin].text}:${data.children[Hfin].children[Mfin].text}`;
      return {
        step: '00:05',
        start: max,
        end: min,
      };
    },
    // 出发
    departTimeOption() {
      const key = this.editFrom.accomodation || constants.Accomodation01;
      const conList = constants.SendDateRange[key];
      const labelList = conList.map((item) => item.text);
      const receiveList = constants.DateOptions.filter(item => labelList.includes(item.label))
      return receiveList;
    },
    dialogTitle() {
      return this.editFrom.attend === Attend02 ? '新增问卷' : '编辑'
    },
    isNoAttend() {
      return this.editFrom.attend !== Attend01
    }
  },
  mounted() {
  },
  // watch: {
  //   receivePicker: {
  //     handler(val) {
  //       console.log(val, '===================')
  //     },
  //     immediate: true,
  //     deep: true
  //   }
  // },
  // mounted() {
  //     const key = this.editFrom.accomodation || constants.Accomodation01;
  //     const conList = constants.ReceiveDateRange[key];
  //     console.log(conList, '===================')
  // },
  methods: {
    onAccomodationChange(val) {
      if (val === Accomodation00) {
        this.$set(this.editFrom, 'room', ROOM_TYPE_0);
      } else {
        this.$set(this.editFrom, 'room', ROOM_TYPE_1);
      }
      this.receiveDate = null;
      this.receiveMin = null;
      this.editFrom.receiveTime = null;

      this.sendDate = null;
      this.sendMin = null;
      this.editFrom.sendTime = null;
    },
    validatePhone(rule, value, callback) {
      if (value && !getMobileTest(value)) {
        callback(new Error('联系电话格式有误，请您再次确认。'));
      } else {
        callback();
      }
    },
    onClose() {
      this.receiveDate = null;
      this.receiveMin = null;
      this.sendDate = null;
      this.sendMin = null;
      const editFrom = {...this.editFrom}
      const newEdit = {...editFrom}
      for (const key in editFrom) {
        if (editFrom.hasOwnProperty(key)) {
          newEdit[key] = null
        }
      }
      this.editFrom = {...newEdit}

      this.$emit('update:visible', false)
    },
    onAttendChange(val) {
      if (val === Attend00) {
        const {name, clientId, attend} = this.editFrom
        const editFrom = {...this.editFrom}
        const newEdit = {...editFrom}
        for (const key in editFrom) {
          if (editFrom.hasOwnProperty(key)) {
            newEdit[key] = null
          }
        }
        this.editFrom = {...newEdit, name, clientId, attend}
      }
    },
    onReceiveChange() {
      this.editFrom = {
        ...this.editFrom,
        receivePhone: null,
        receiveStation: null,
        receiveNumber: null,
        receiveTime: null,
        receiveCompany: null,
      }
      this.receiveMin = null
      this.receiveDate = null
    },
    onSendChange() {
      this.editFrom = {
        ...this.editFrom,
        sendPhone: null,
        sendStation: null,
        sendTime: null
      }
      this.sendMin = null
      this.sendDate = null
    },
    onDateChange(valKey, key) {
      if (key === 'sendTime') {
        if (valKey === 'sendDate') this.sendMin = null;
        if (typeof `${this.sendDate} ${this.sendMin}` === "string" && Date.parse(`${this.sendDate} ${this.sendMin}`)) {
          this.editFrom.sendTime = moment(new Date(`${this.sendDate} ${this.sendMin}`)).format("YYYY/MM/DD HH:mm")
        }

      } else if (key === 'receiveTime') {
        if (valKey === 'receiveDate') this.receiveMin = null;
        if (typeof `${this.receiveDate} ${this.receiveMin}` === "string" && Date.parse(`${this.receiveDate} ${this.receiveMin}`)) {
          this.editFrom.receiveTime = moment(new Date(`${this.receiveDate} ${this.receiveMin}`)).format("YYYY/MM/DD HH:mm")
        }
      }
    },
    onSubmit: lodash.debounce(function () {
      const editFrom = {...this.editFrom}
      let isNoDiff = true
      for (const key in editFrom) {
        if (editFrom.hasOwnProperty(key) && editFrom[key] !== this.values[key]) {
          isNoDiff = false
        }
      }
      if (isNoDiff) {
        this.$message.warning("问卷信息没有修改，不需要更新问卷")
        return
      }

      this.$refs.editFrom.validate(async valid => {
        if (valid) {
          const {receiveTime, sendTime, emailAddress} = this.editFrom
          const res = await userOperateResult({
            ...this.editFrom,
            emailAddress: emailAddress ? emailAddress.trim() : '',
            receiveTime: typeof receiveTime === "string" && Date.parse(receiveTime) ? moment(receiveTime).format("YYYY/MM/DD HH:mm") : '',
            sendTime: typeof sendTime === "string" && Date.parse(sendTime) ? moment(sendTime).format("YYYY/MM/DD HH:mm") : ''
          })
          if (res) {
            let {code, msg} = res
            if (code === '0') {
              this.onClose()
              this.$message.success(`${this.dialogTitle}成功`)
              this.$emit('onSuccess', res)
            } else {
              this.$message.error(msg || '服务异常，请联系客服')
            }
          }
        }
      })
    }, 200)
  },
  watch: {
    'values': {
      handler(newVal, oldVal) {
        console.log(newVal, oldVal)
        const editFrom = {...this.editFrom}
        const newEdit = {...editFrom}
        for (const key in editFrom) {
          if (editFrom.hasOwnProperty(key)) {
            newEdit[key] = newVal.attend !== Attend02 || ['name', 'clientId', 'attend'].includes(key) ? newVal[key] : null
          }
        }
        const {receiveTime, sendTime} = newEdit
        this.editFrom = {
          ...newEdit
        }
        if (typeof receiveTime === "string" && Date.parse(receiveTime)) {
          this.receiveDate = moment(new Date(receiveTime)).format('YYYY/MM/DD')
          this.receiveMin = moment(new Date(receiveTime)).format('HH:mm')
        }

        if (typeof sendTime === "string" && Date.parse(sendTime)) {
          this.sendDate = moment(new Date(sendTime)).format('YYYY/MM/DD')
          this.sendMin = moment(new Date(sendTime)).format('HH:mm')
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="less">
.edit-dialog-wrapper {
  background: #fff;
  margin-top: 18px !important;

  .el-dialog__title {
    font-weight: bold;
  }

  .el-dialog__body {
    padding: 14px 20px;
  }


  .edit-input {
    width: 270px !important;
  }

  .el-select {
    width: 270px;
  }

  .el-form-item {
    margin-bottom: 18px;
  }

  .el-form-item.is-success .el-input__inner, .el-form-item.is-success .el-input__inner:focus, .el-form-item.is-success .el-textarea__inner, .el-form-item.is-success .el-textarea__inner:focus {
    border-color: #dcdfe6;
  }
}
</style>
